import {tokenDefinition} from "../../token/tokenDefinition.mjs";
import {TokenType} from "../../token/tokenType.mjs";
import {TokenName} from "./tokenName.mjs";
import {NodeName} from "./nodeName.mjs";
import {Node} from "../../node/node.mjs";

const title1 = tokenDefinition({
    name: TokenName.TITLE_1,
    type: TokenType.KEYWORD,
    tokenMatcher: /^\s*# /,
    contentMatcher: /^\s*# /
});

const title2 = tokenDefinition({
    name: TokenName.TITLE_2,
    type: TokenType.KEYWORD,
    tokenMatcher: /^[\r\t\f\v ]*## /,
    contentMatcher: /^[\r\t\f\v ]*## /
});

const title3 = tokenDefinition({
    name: TokenName.TITLE_3,
    type: TokenType.KEYWORD,
    tokenMatcher: /^[\r\t\f\v ]*### /,
    contentMatcher: /^[\r\t\f\v ]*### /
});

class Title {

    constructor() {

    }

    consume(tokenIterator, nodeIterator) {

        let nodeName = null;
        let tokenName = tokenIterator.token().name;

        switch (tokenName) {
            case TokenName.TITLE_1:
                nodeName = NodeName.TITLE_1;
                break;
            case TokenName.TITLE_2:
                nodeName = NodeName.TITLE_2;
                break;
            case TokenName.TITLE_3:
                nodeName = NodeName.TITLE_3;
                break;
            default:
                return;
        }

        tokenIterator.eatTokens(1)

        nodeIterator.addClosedNode(
            new Node(nodeName, this.matchFullLine(tokenIterator), null, nodeIterator.currentParentNode).close()
        )

    }

    matchFullLine(tokenIterator) {
        let value = ""
        while (tokenIterator.hasNext(1) && tokenIterator.token().name !== TokenName.LINE_FEED) {
            value += tokenIterator.token().value
            tokenIterator.eatTokens(1)
        }

        // eat the final LineFeed
        tokenIterator.eatTokens(1)

        return value
    }

    toHtml(node, toHtml, idProvider) {
        switch (node.name) {
            case NodeName.TITLE_1:
                return "<h1>" + node.value + "</h1>"
            case NodeName.TITLE_2:
                return "<h2>" + node.value + "</h2>"
            case NodeName.TITLE_3:
                return "<h3>" + node.value + "</h3>"
        }
    }


}

export {Title, title1, title2, title3}